export const customerFormDefaults = {
  name: "",
};
